import { render } from "./Patients_List.vue?vue&type=template&id=04ec3eb9"
import script from "./Patients_List.vue?vue&type=script&lang=js"
export * from "./Patients_List.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__